import '@babel/polyfill';
import 'whatwg-fetch';
import React from 'react';
import ReactDOM from 'react-dom';
import 'normalize.css';
import './index.css';
import App from './app';
import FilterApp from '../../components/filter-app';
import InitRun from '../../common/initial';

InitRun();

ReactDOM.render(
  <FilterApp>
    <App />
  </FilterApp>,
  document.getElementById('root')
);
